import apiRequestActionCreator from '../apiRequestActionCreator';
import { addItem, fetchCollection, fetchItem, processItemError } from '../collectionActions';

const fetchIssues = fetchCollection({
    apiCollectionName: 'customer-issues',
    collectionActionName: 'ISSUES',
    paramsFunction: ({ params: { currentStatus, ...params } }) => {
        let active;
        if (currentStatus === 'allOpen') {
            active = true;
        } else if (currentStatus === 'allClosed') {
            active = false;
        }
        return {
            ...params,
            active,
        };
    },
});

const fetchIssue = fetchItem({
    apiCollectionName: 'customer-issues',
    itemActionName: 'ISSUE',
});

const uploadIssueAttachment = ({ formData, id }) =>
    apiRequestActionCreator({
        actionName: 'ISSUE_ATTACHMENT',
        params: {
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            method: 'post',
            url: `customer-issues/${id}/attachments`,
        },
    });

const addIssueComment = ({ comment, itemId: issueId, tab }) =>
    apiRequestActionCreator({
        actionName: 'ISSUE_COMMENTS',
        params: {
            data: {
                comment,
                internal: tab === 'INTERNAL_NOTE',
            },
            method: 'post',
            params: {
                issueId,
            },
            url: `comments`,
        },
        processError: error => processItemError({ error }),
        snackbarErrorField: 'comment',
    });

const editIssueComment = ({ comment, id }) =>
    apiRequestActionCreator({
        actionName: 'EDIT_ISSUE_COMMENTS',
        params: {
            data: {
                comment,
            },
            method: 'put',
            url: `comments/${id}`,
        },
        processError: error => processItemError({ error }),
        snackbarErrorField: 'comment',
    });

const deleteIssueComment = ({ id }) =>
    apiRequestActionCreator({
        actionName: 'DELETE_ISSUE_COMMENTS',
        params: {
            method: 'delete',
            url: `comments/${id}`,
        },
    });

const showIssueCreationSuccessMessage = () => ({ type: 'ISSUE_CREATION_SUCCESS' });

const addIssue = addItem({
    apiCollectionName: 'customer-issues',
    itemActionName: 'ISSUE',
    params: {
        timeout: 30 * 60000,
        transformRequest: [({ attachments, ...rest }) => JSON.stringify(rest)],
    },
    processSuccessResponse: async ({ data }, { data: { attachments } }, dispatch) => {
        if (attachments && attachments.length) {
            for (let index = 0; index < attachments.length; index += 1) {
                const formData = new FormData();
                formData.append('file', attachments[index]);

                await dispatch(uploadIssueAttachment({ formData, id: data.id }));
            }
        }
        dispatch(showIssueCreationSuccessMessage());
        return data;
    },
});

export {
    addIssue,
    addIssueComment,
    deleteIssueComment,
    editIssueComment,
    fetchIssue,
    fetchIssues,
    uploadIssueAttachment,
};
